<template>
	<div id="multiselectstanding">
		<div class="dropdown dropdown-filter" @click="showDropdown">
			<div class="overselect"></div>
			<div class="c-form-input">
				<h3 class="raleway-semi-p13">Nombre d'étoiles</h3>
				<img src="../../images/Fleche haut.svg" v-set-alt v-if="show" />
				<img src="../../images/flechebas-simple.svg" v-set-alt v-else />
			</div>
		</div>
		<div class="multiselect" v-if="show">
			<ul>
				<div class="row-selectoptions mt-3" :class="{ row: !isPhone }">
					<div :class="{ 'col-8': !isPhone }">
						<li>
							<input type="checkbox" id="0-star" value="0" v-model="selectedStar" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="0-star">
								Non classé <span class="filter-count">({{ getStandingCount(0) || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="1-star" value="1" v-model="selectedStar" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="1-star">
								1 étoile <span class="filter-count">({{ getStandingCount(1) || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="2-star" value="2" v-model="selectedStar" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="2-star">
								2 étoiles <span class="filter-count">({{ getStandingCount(2) || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="3-star" value="3" v-model="selectedStar" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="3-star">
								3 étoiles <span class="filter-count">({{ getStandingCount(3) || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="4-star" value="4" v-model="selectedStar" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="4-star">
								4 étoiles <span class="filter-count">({{ getStandingCount(4) || 0 }})</span>
							</label>
						</li>
						<li>
							<input type="checkbox" id="5-star" value="5" v-model="selectedStar" />
							<label class="raleway-reg-p13" :class="{ 'ml-2': !isPhone }" for="5-star">
								5 étoiles <span class="filter-count">({{ getStandingCount(5) || 0 }})</span>
							</label>
						</li>
					</div>
				</div>
			</ul>
		</div>
	</div>
</template>

<script>
	import Sliderstars from 'pages/destinations/Sliderstars';

	export default {
		name: 'multiselectstanding',
		components: { Sliderstars },
		props: ['options', 'filterCounts'],
		data() {
			return {
				show: false,
				selectedStar: [],
			};
		},
		methods: {
			showDropdown() {
				this.show = !this.show;
			},
			getStandingCount(standing) {
				if (!this.filterCounts) return 0;
				
				let count = 0;
				const standingStr = String(standing);
				
				// Sum count from standing (keys are integers)
				if (this.filterCounts.standing) {
					const standingData = this.filterCounts.standing.find(s => s.key === standing || String(s.key) === standingStr);
					count += standingData ? standingData.count : 0;
				}
				
				// Sum count from classification_outside_france (keys are strings)
				if (this.filterCounts.classification_outside_france) {
					const classificationData = this.filterCounts.classification_outside_france.find(c => String(c.key) === standingStr);
					count += classificationData ? classificationData.count : 0;
				}
				
				return count;
			},
		},
		watch: {
			selectedStar(val) {
				this.$emit('checked', val, 'standing');
			},
		},
    computed: {
      isPhone() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
          return true;
        } else {
          return false;
        }
      },
    },
	};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter">
.filter-count {
  color: #666;
  font-size: 0.9em;
  font-weight: normal;
  margin-left: 4px;
}
</style>
